import { render, staticRenderFns } from "./IEnvOStudentForm.vue?vue&type=template&id=2ff8aa1d&scoped=true&"
import script from "./IEnvOStudentForm.vue?vue&type=script&lang=js&"
export * from "./IEnvOStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./IEnvOStudentForm.vue?vue&type=style&index=0&id=2ff8aa1d&prod&scoped=true&lang=scss&"
import style1 from "./IEnvOStudentForm.vue?vue&type=style&index=1&id=2ff8aa1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8aa1d",
  null
  
)

export default component.exports